import { createSlice } from "@reduxjs/toolkit";
import { deletePeriodBuilder, createPeriodBuilder } from "./builders";

const initialState = {
  period: [],
};

export const periodSlice = createSlice({
  name: "period",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    deletePeriodBuilder(builder);
    createPeriodBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

export const selectPeriod = (state) => state.period.period;
export default periodSlice.reducer;
